<div class="card card-custom" *ngIf="!showingInSettlement" [ngClass]="{'disabled-container': disableDetailFields}">
    <div class="card-header detalle-card-header flex-column align-items-stretch">
        <div class="d-flex justify-content-between align-items-center w-100 flex-wrap">
            <div class="card-title mb-0">
                <p class="mb-0">Detalles</p>
            </div>
            <div class="d-flex align-items-center flex-wrap detalle-card-header__toggles">
                <ng-container *ngTemplateOutlet="dtePagadoTemplate"></ng-container>
                <ng-container *ngTemplateOutlet="ivaCheckboxTemplate"></ng-container>
            </div>
        </div>
        <div class="exempt-info-message mt-3" *ngIf="showInInvoiceTicket">
            <span class="exempt-info-label">Importante:</span>
            El tipo de documento cambia a exento solo si todas las casillas de los detalles estan marcadas como exentas.
            <i class="flaticon-warning exempt-info-icon"></i>
        </div>
    </div>
    <div class="card-content">
        <div class="card-body">
            <!-- <ngb-alert *ngIf="maxItemError">
                    {{sizeMessage}}
            </ngb-alert> -->
            <alert id="alert-size" style="z-index: 1050;"></alert>
            <div class="row">
                <app-cuadro-producto-detalle>
                    <div accionesDescripciones><ng-container *ngTemplateOutlet="botonDescripciones"></ng-container></div>
                </app-cuadro-producto-detalle>
                <br>
            </div>
            <div class="detalle-item-list" [ngClass]="{ 'detalle-item-list--highlight': showInInvoiceTicket }">
                <!-- loop de lista de items de detalles -->
                <div *ngFor="let detalle of listaDetalles;let index=index" app-item-detalle-dte
                    [detalleDte]="detalle" [detalleNumero]="index+1" (deleteDetalle)="deleteItem(index)" [hideExentoColumn] = "hideExentoColumn">
                </div>
                <!-- fin loop de lista de items de detalles -->
            </div>
            <div class="detail-manual-action">
                <button type="button" class="btn btn-link detail-manual-action__button" (click)="agregarDetalle()">
                    <i class="flaticon-plus"></i>
                    Agregar nueva línea de detalle
                </button>
            </div>
        </div>
    </div>
</div>
<div class="card card-custom liquidacion-detalles" *ngIf="showingInSettlement">
    <div class="card-header detalle-card-header flex-column align-items-stretch">
        <div class="card-title mb-0">
            <p class="mb-0">Detalles de documentos</p>
        </div>
    </div>
    <div class="card-content">
        <div class="card-body">
            <alert id="alert-size" style="z-index: 1050;"></alert>
            <app-cuadro-documento-detalle>
                <div accionesDescripciones><ng-container *ngTemplateOutlet="botonDescripciones"></ng-container></div>
            </app-cuadro-documento-detalle>

            <div class="liquidacion-detalle-list" *ngIf="listaDetalles?.length">
                <ng-container *ngFor="let detalle of listaDetalles; let index = index">
                    <div *ngIf="detalle.relatedProductId; else documentoManual" app-item-detalle-dte
                        [detalleDte]="detalle" [detalleNumero]="index + 1" (deleteDetalle)="deleteItem(index)">
                    </div>
                    <ng-template #documentoManual>
                        <div app-item-detalle-documento [detalleDte]="detalle"
                            [detalleNumero]="index + 1" (deleteDetalle)="deleteItem(index)"></div>
                    </ng-template>
                </ng-container>
            </div>
            <div class="detail-manual-action">
                <button type="button" class="btn btn-link detail-manual-action__button" (click)="agregarDetalle()">
                    <i class="flaticon-plus"></i> Agregar nueva línea de detalle
                </button>
            </div>
        </div>
    </div>
</div>
<ng-template #botonDescripciones>
    <button type="button" class="btn btn-sm btn-light-primary text-nowrap"
        [disabled]="!listaDetalles?.length" [attr.aria-expanded]="todasDescripcionesExpandidas"
        (click)="alternarDescripciones()">
        <i class="fas" [ngClass]="todasDescripcionesExpandidas ? 'fa-angle-double-up' : 'fa-angle-double-down'" aria-hidden="true"></i>
        {{ todasDescripcionesExpandidas ? 'Contraer descripciones' : 'Expandir descripciones' }}
    </button>
</ng-template>
